<template>
    <div class="welcomeViewModulesVue">
        <div class="news" v-for="item, index in componentsList" :key="index">
            <div class="img">
                <img :src="item.noticeThumbnail" alt="" style="width: 100%;height: 100%;border-radius: 9px;">
            </div>
            <div class="value">
                <div class="head" style=" -webkit-box-orient: vertical;">{{ item.noticeTitle }}</div>
                <div class="content" style="-webkit-box-orient: vertical;">
                    {{ item.noticeContent }}
                </div>
                <div class="date">{{ $root.formatDate(item.noticeDate) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        institutionList: {
            type: Array,
            default: () => { return [] }
        }
    },
    data() {
        return {
            componentsList: []
        }
    },
    watch: {
        institutionList(value) {
            this.componentsList = value
            console.log(value, 'value')
        }
    }
}
</script>

<style lang="scss" scoped>
.welcomeViewModulesVue {
    .news {
        display: flex;
        margin-bottom: 14px;
        align-items: center;

        .img {
            height: 88px;
            width: 120px;
            border-radius: 9px;
        }

        .value {
            flex: 1;
            margin-left: 15px;


            .head {
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 1px;
                margin-bottom: 10px;
                width: 461px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;

            }

            .content {
                color: #b0b3b2;
                width: 461px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;

                margin-bottom: 8px;
            }

            .date {
                color: #b0b3b2;
            }
        }

        &:last-child {
            margin-bottom: 0px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// welcomeViewModules.vue?ea68147c